import $ from 'jquery';
import throttle from 'lodash/throttle';

import breakpoints from '../helpers/breakpoints';

const $window = $(window);
const $page = $('.js-full-page-container');

export default class FullPage {
  constructor($c) {
    this.$c = $c;
    this.$scenes = $c.find('.js-full-page-scene');
    this.initialized = false;

    $window.off('resize.kriosFullPage');
    $window.on('resize.kriosFullPage', throttle(() => this.update(), 100));
    this.update();
  }
  init() {
    this.$c.fullpage({
      sectionSelector: '.js-full-page-scene',
      verticalCentered: false,
      licenseKey:"B3DA5159-B3F34A99-893F64C0-0C072FE9",
      scrollBar: true,
      menu: '.js-full-page-menu',
      normalScrollElements: '.remodal-wrapper',
      onLeave: (index, nextIndex) => this.updateClass(nextIndex)
    });

    FullPage.addHandlers();
    this.updateClass(1);
    this.initialized = true;
  }
  destroy() {
    $.fn.fullpage.destroy('all');
    this.updateClass();
    this.initialized = false;
  }
  update() {
    const windowWidth = window.innerWidth;

    if (windowWidth <= breakpoints.mobile) {
      if (this.initialized) {
        this.destroy();
      }
    } else if (!this.initialized) {
      this.init();
    }
  }
  updateClass(number) {
    // удалить другие классы
    this.$scenes.each((i, scene) => {
      const $scene = $(scene);
      const pageClass = $scene.data('page-class');

      $page.removeClass(pageClass);
    });

    // добавить новый класс
    if (number) {
      const $scene = this.$scenes.eq(number - 1);
      $page.addClass($scene.data('page-class'));
    }
  }
  static addHandlers() {
    $('.js-full-page-down').on('click', (e) => {
      e.preventDefault();
      $.fn.fullpage.moveSectionDown();
    });

    $('.js-full-page-start').on('click', (e) => {
      e.preventDefault();
      $.fn.fullpage.moveTo(1);
    });
  }
  static lock(value) {
    if (this.initialized) {
      $.fn.fullpage.setAllowScrolling(!value);
      $.fn.fullpage.setKeyboardScrolling(!value);
    }
  }
}
